import { ReactElement } from 'react';
import { JobAnnotationToolsContainer } from '../../../../modules/jobs/containers/details/JobAnnotationTools.container';

export const TrainingDetailsAnnotationToolsView = (): ReactElement => <JobAnnotationToolsContainer />;
